module.exports = __webpack_public_path__ + "img/icon-disease-inactive.bb824711.png";